<template>
    <v-card
        class="resume-card mx-auto my-5"
        :color="color"
        dark
        max-width="1000"
        v-bind="$attrs">
        <v-card-title>
            <v-icon
                :large="$vuetify.breakpoint.mdAndUp"
                left>
                {{ icon }}
            </v-icon>
            <span
                ref="heading"
                class="text-body-2 text-md-h6 font-weight-light">
                {{ scrambledTitle }}
            </span>
        </v-card-title>
        <slot />
    </v-card>
</template>

<script>
import { ref } from 'vue';
import { useScrambleReveal } from '@/composables/useTextScramble';

/**
 * Colored card with an icon + title header, shared by every resume panel. The title
 * scrambles in when it first comes into view. Extra attrs go to v-card.
 */
export default {
    name: 'ResumeCard',
    inheritAttrs: false,
    props: {
        title: { type: String, required: true },
        icon: { type: String, required: true },
        color: { type: String, required: true },
    },
    setup(props) {
        const heading = ref(null);
        // The delay lets the card's enter animation finish first.
        const scrambledTitle = useScrambleReveal(heading, () => props.title, { startDelay: 500 });

        return { heading, scrambledTitle };
    },
};
</script>

<style scoped>
.resume-card {
    box-shadow: inset 3px 0px 7px 0px #00000050 !important;
}
/* Twilight: the card's color sinks into the night, its edge keeps glowing. */
[data-theme='twilight'] .resume-card {
    background-image: linear-gradient(135deg, rgba(5, 7, 15, 0.5), rgba(5, 7, 15, 0.8));
    border: 1px solid;
}
</style>
